




import Vue from 'vue'
import Utils from '@/helpers/Utils'
import { apiRoutes } from '@/helpers/ApiRoutes'

const SUBSCRIPTION_KEY = 'subscribedForPush'

export default Vue.extend({
  name: 'WebPush',

  computed: {
    isPushEnabled (): boolean {
      return Notification.permission !== 'denied'
    },
    isSubscribed (): boolean {
      return localStorage.getItem(SUBSCRIPTION_KEY) === '1'
    }
  },

  created () {
    if (this.$store.getters.isAuthenticated) {
      if (!this.isSubscribed && this.isPushEnabled) {
        this.subscribe()
      }
    }
  },

  methods: {
    notifyServer (subscription: PushSubscription) {
      this.$axios.post(apiRoutes.setDeviceId, subscription)
        .catch(() => { /* do nothing */ })
    },
    subscribe () {
      // Service worker doesn't exist in private / incognito mode
      navigator.serviceWorker && navigator.serviceWorker.ready
        .then(serviceWorkerRegistration => {
          serviceWorkerRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: Utils.urlBase64ToUint8Array(process.env.VUE_APP_VAPID_PUBLIC_KEY)
          })
            .then(subscription => {
              localStorage.setItem(SUBSCRIPTION_KEY, '1')

              this.notifyServer(subscription)
            })
            .catch(() => { /* do nothing */ })
        })
    }
  }
})
